<template>
  <div class="bookingexpired-list">
    <h2>Booking Expired List</h2>
    <button class="btn btn-primary mb-4" @click="addBookingExpired">Add New Booking Expired</button>
    <SearchBox v-model="search" class="col-md-3 col-12" />
    <v-client-table
      :data="filteredBookingExpired"
      :columns="columns"
      :options="options"
      @row-click="showBookingExpired"
    ></v-client-table>
  </div>
</template>
  
  <script>
  let api = window.api;
  import SearchBox from "@/components/tools/SearchBox.vue";
  
  export default {
    name: "BookingExpiredList",
    components: {
      SearchBox,
    },
    data() {
      return {
        bookingExpired: [],
        search: "",
        columns: ["id", "Reference", "DaysToExpire"],
        options: {
          headings: {
            Reference: "Reference",
            DaysToExpire: "Days To Expire",
          },
          sortable: ["id", "Reference", "DaysToExpire"],
          filterable: ["id", "Reference", "DaysToExpire"],
          perPage: 10,
          perPageValues: [10, 20, 50],
          skin: "table table-striped table-hover",
        },
      };
    },
    async mounted() {
      await this.fetchBookingExpired();
    },
    computed: {
      filteredBookingExpired() {
        if (!this.bookingExpired)  return []
        if (!this.search) return this.bookingExpired;
          
        const searchLower = this.search?.toLowerCase();
        return this.bookingExpired.filter((booking) => {
          return (
            booking.id?.toString().toLowerCase().includes(searchLower) ||
            booking.Reference?.toLowerCase().includes(searchLower) ||
            booking.DaysToExpire?.toString().toLowerCase().includes(searchLower)
          );
        });
      },
    },
    methods: {
      showBookingExpired(data) {
        this.$router.push({ name: "bookingexpired", params: { id: data.row.id } });
      },
      addBookingExpired() {
        this.$router.push({name: 'bookingexpired', params: {id: null}})
      },
      async fetchBookingExpired() {
        this.bookingExpired = await api.get("/api/bookingexpired/");
      },
    },
  };
  </script>
  
  <style scoped>
  .bookingexpired-list {
    margin: 20px;
  } 
  .mb-4 {
    margin-bottom: 16px;
  }
  </style>
  